define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var core = require('core');
    var user = require('user');
    var server = require('server');
    var config = require('config');
    var AuthManager = require('managers/auth.manager');

    /**
     * @class
     * @name AuthManager
     */
    module.exports = AuthManager.extend({

        /**
         * @private
         * @param  {Object} options
         * @return {Deferred}
         */
        login: function(options) {
            var loginState = $.Deferred();

            if (!window.Playtech.API?.auth?.login) {
                loginState.reject();

                return loginState.promise();
            }

            var userName = user.get('userName');
            var password = user.get('password');
            var rememberMeLogin = user.get('rememberMeLogin');
            var fitToPlay = user.get('fitToPlay');
            var afterRegisterLogin = user.get('afterRegisterLogin');
            var loginMode = user.get('loginMode');

            const handleSuccess = (response) => {
                user.unset('password');
                loginState.resolve(response);
                this.getLoginActionsState();
                options.success(response.data);
            };

            const handleError = (error) => {
                if (afterRegisterLogin && error.data?.errorCode === 301) {
                    const popupId = 'registration-recaptcha-popup';

                    Playtech.API.popup.showPopup('reCaptcha', {
                        id: popupId,
                        operation: 'login',
                        onReCaptchaTokenValidate: () => {
                            Playtech.API.popup.closePopups(popupId);
                            window.Playtech.API.auth.login(userName, password, rememberMeLogin, afterRegisterLogin, loginMode, Boolean(fitToPlay))
                                .then(handleSuccess)
                                .catch(handleError);
                        },
                        onClose: () => {
                            // no op
                        },
                        onReCaptchaTokenError: () => {
                            Playtech.API.popup.closePopups(popupId);
                        }
                    });
                }

                loginState.reject(error);
                options.error(error);
            };

            window.Playtech.API.auth.login(userName, password, rememberMeLogin, afterRegisterLogin, loginMode, Boolean(fitToPlay))
                .then(handleSuccess)
                .catch(handleError);

            return loginState.promise();
        },

        getLoginActionsState: function() {
            return server.send({
                ID: 35619,
                description: 'Player missing limits',
                responses: [35620, 35621]
            }).then(response => {
                let performNavigation = response.data &&
                    response.data.missingLimits &&
                    response.data.missingLimits.some(limit => limit.type === 'loss');

                setTimeout(function() {
                    performNavigation && core.navigate(this._getLossLimitsLink());
                }.bind(this), 300);
            });
        },

        _getLossLimitsLink: function() {
            const currentLanguage = Playtech.API.language.getCurrentLanguage();
            const lang = currentLanguage || config.get('defaultLocale');
            var dynamicTags = config.get('dynamicTags') || {};
            const lossLimitDynamicTagName = 'DTAG_RG_LOSS_LIMITS_' + lang.toUpperCase();

            var urlLossLimitDynamicTag = dynamicTags[lossLimitDynamicTagName];

            return urlLossLimitDynamicTag;
        }
    });
});
